























































































import Vue from "vue";
import { State, Action, Getter } from "vuex-class";
import { Component, Prop, Watch } from "vue-property-decorator";
import { FinancialReportData } from "@/entities";
import FormattedNumber from "@/components/common/Inputs/FormattedNumber.vue";
import VCurrencyField from "@/components/common/CurrencyInput/VCurrencyField.vue";
import { Notification, INotification } from "@/entities";
import { Locales } from "@/i18n/locales";

const namespace: string = "financialReport";

@Component({
  components: {
    FormattedNumber,
    VCurrencyField
  },
})
export default class CashFlowProjectionTable extends Vue {
  @State(namespace) financialReport!: FinancialReportData;

  @Prop() items: Array<any>;
  @Prop() statement: any;
  @Prop() grantInfo: any;
  @Prop() isFinalReport: boolean;
  @Prop() categories: Array<any>;
  @Prop() currency: string;
  @Prop() formOptions: any;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  get periods() {
    return this.financialReport.finReports;
  }

  get futurePeriods() {
    return this.financialReport.finReports.filter(
      (x) =>
        x.FinancialReportId >
        this.financialReport.selectedReport.FinancialReportId
    );
  }

  get dictCategory() {
    return this.categories.reduce((obj, catg) => {
      obj[catg.id] = catg.name;
      return obj;
    }, {});
  }

  get budgetInfo() {
    if (
      this.financialReport.grantData &&
      this.financialReport.grantData.applicationBudget
    ) {
      return this.financialReport.grantData.applicationBudget;
    }
  }

  periodsIndex(finReportId) {
    return this.financialReport.finReports
      .map((x) => {
        return x.FinancialReportId;
      })
      .indexOf(finReportId);
  }

  // compare projection amount with application budget amount
  validateAmount(categoryId, amount): boolean {
    let totalCategoryBudgetAmount = 0;

    // Validates category is indirect cost
    if (categoryId === 1000 && this.budgetInfo.summary.indirectCost) {
      totalCategoryBudgetAmount =
        this.budgetInfo.summary.indirectCost.find((x) => x.series == "Total")
          .value || 0;
    } else {
      let categoryList = this.budgetInfo.data_row.filter(
        (x) => x.category_id == categoryId
      );

      categoryList.forEach((cat) => {
        totalCategoryBudgetAmount +=
          cat.series_data.find((x) => x.key == "Total").value || 0;
      });
    }

    return amount <= totalCategoryBudgetAmount;
  }

  setAmount(item, finReportId, val) {
    if (this.validateAmount(item.categoryId, val)) {
      item[finReportId] = val;

      // get next reporting period
      if (this.financialReport.grantData.finReport) {
        let selReport = this.financialReport.selectedReport;

        // get next report id
        let nextReport = this.financialReport.grantData.finReport.find(
          (x) => x.FinancialReportId > selReport.FinancialReportId
        );

        // get summary report item
        let summaryReport: any = this.statement.summaryReport.find(
          (x) => x.categoryId == item.categoryId
        );

        if (!nextReport) summaryReport.forecast = 0;

        summaryReport.forecast = val;
      }
    } else {
      item[finReportId] = 0;

      this.$store.commit(
        "application/setNotification",
        new Notification({
          snack: true,
          isHtml: true,
          text: this.$t(
            "Amount of cash flow projection cannot exceed budget amount."
          ),
          color: "error",
        } as INotification),
        { root: true }
      );
    }
  }

  calcTotal(periodId: number) {
    if (this.items) {
      return this.items.map((x) => x[periodId]).reduce((a, b) => a + b || 0, 0);
    }
  }
}
